import { useQuery } from 'react-query';
import { fetchInquiries } from '@/api/inquiries';

function useInquiries(page: number) {
  return useQuery(['inquiries', page], () => fetchInquiries(page));
}

export default useInquiries;